import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home'
import Categorias from '@/views/Categorias'
import Produtos from '@/views/Produtos'
import Pedidos from '@/views/Pedidos'
import Auth from '@/auth/Auth'
import CardapioMonster from '@/views/Pages/CardapioMonster'
import Empresas from  '@/views/Empresas'

import { userKey } from '@/global'

Vue.use(VueRouter)

const routes = [
  { name: 'home', path: '/home', component: Home, meta: { requiresAdmin: true } },
  { name: 'auth', path: '/login', component: Auth, meta: { requiresAdmin: false } },
  { name: 'produtos', path: '/produtos', component: Produtos, meta: { requiresAdmin: true } },
  { name: 'monsterburgerjp', path: '/monsterburgerjp', component: CardapioMonster, meta: { requiresAdmin: false } },
  { name: 'categorias', path: '/categorias', component: Categorias, meta: { requiresAdmin: true } },
  { name: 'pedidos', path: '/pedidos', component: Pedidos, meta: { requiresAdmin: true } },
  { name: 'empresas', path: '/empresas', component: Empresas, meta: { requiresAdmin: true } },
]

/* const router = new VueRouter({
  routes
}) */

const router = new VueRouter({
  mode: 'history',
  routes
})

//Controla segurança de rotas
router.beforeEach((to, from, next) => {
  const json = sessionStorage.getItem(userKey)
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    const user = JSON.parse(json)
    if (user === "GERENTE" || user === "ADMIN" || user === "CHECKIN" || user === "CHECKOUT")
      next()
    else
      next({ path: '/' })
  } else {
    next()
  }
})

export default router